document.addEventListener('DOMContentLoaded', function () {
    const body = document.querySelector('body');
    console.log("DOMContentLoaded event fired. Script is running.");

    let modalProductData = {
        handle: null,
        variantId: null,
        quantity: 1,
        selectedOptions: {}
    };

    function isValidColor(color) {
        let s = new Option().style;
        s.color = color;
        return s.color !== '';
    }

    function extractColor(value) {
        let match = value.match(/\(([^)]+)\)/);
        if (match && isValidColor(match[1].trim())) {
            return match[1].trim();
        }
        return null;
    }

    function findMatchingVariant(selectedOptions, variants, data) {
        return variants.find(variant => {
            return Object.keys(selectedOptions).every(optionName => {
                const lowerOptionName = optionName.toLowerCase();
                const selectedValue = selectedOptions[optionName];

                if (lowerOptionName === 'title' && selectedValue === 'Default Title') {
                    return true;
                }

                for (let i = 1; i <= 3; i++) {
                    const variantOption = variant[`option${i}`];
                    if (data.options[i - 1] && lowerOptionName === data.options[i - 1].name.toLowerCase()) {
                        return variantOption === selectedValue;
                    }
                }

                return false;
            });
        });
    }

    function formatPrice(price) {
        if (typeof price === 'number') {
            price = (price / 100).toFixed(2);
        } else if (typeof price === 'string') {
            price = (parseFloat(price) / 100).toFixed(2);
        }
        return '$' + price;
    }

    function updatePrice(variant, data, salePriceElement, comparePriceElement) {
        if (variant) {
            let price = variant.price;
            let compare_price = variant.compare_at_price;
              console.log(price, compare_price)
            if (!(price > compare_price)) {
              salePriceElement.textContent = formatPrice(price);
              comparePriceElement.textContent = compare_price ? formatPrice(compare_price) : "";
            } else {
              salePriceElement.textContent = formatPrice(price);
            }
        } else {
            let price = data.price_min || 0;
            let compare_price = data.compare_at_price_min || 0;
            salePriceElement.textContent = formatPrice(price);
            comparePriceElement.textContent = compare_price ? formatPrice(compare_price) : "";
        }
    }

    function setAddToCartButtonState(addToCartButton, enabled) {
        if (addToCartButton) {
            addToCartButton.disabled = !enabled;
            addToCartButton.style.opacity = enabled ? 1 : 0.5;
            addToCartButton.style.cursor = enabled ? 'pointer' : 'not-allowed';
        }
    }

    function populateModal(data) {
        let modalWrapper = document.querySelector('.modalWrapper');
        if (!modalWrapper) {
            console.error("Modal wrapper not found.");
            return;
        }
        modalWrapper.classList.add('active');

        let title = data.title || "Unknown Product";
        let images = Array.isArray(data.images) ? data.images : [];
        let description = data.description || "";
        let options = Array.isArray(data.options) ? data.options : [];
        let productUrl = `/products/${data.handle}`;
        let variants = data.variants || [];

        let sliderContainer = document.querySelector('.product-side-quick_view-slider');
        let titleElement = document.querySelector('.product-title-side-quick_view');
        let salePriceElement = document.querySelector('.current-sale-price');
        let comparePriceElement = document.querySelector('.current-compare-price');
        let descriptionElement = document.querySelector('.product-description-qucik_view');
        let optionsContainer = document.querySelector('.option-list-items');
        let viewProductLink = document.querySelector('.view-product');
        let quantityInput = document.querySelector('.modalWrapper .input-quantity-wrapper input[type="number"]');
        let plusButton = document.querySelector('.modalWrapper .input-quantity-wrapper .plus-icon');
        let minusButton = document.querySelector('.modalWrapper .input-quantity-wrapper .minus-icon');
        let addToCartButton = document.querySelector('a.add-to-cart-actual-button');
      
        if (!quantityInput){
            console.log("Quantity Input not Found")
            return;
        }
     
        quantityInput.value = 1;
        modalProductData.quantity = 1;

        viewProductLink.href = productUrl;
        optionsContainer.innerHTML = '';

        
        if (sliderContainer) {
            sliderContainer.innerHTML = '';
      
            if (typeof $ !== "undefined" && $(sliderContainer).hasClass('slick-initialized')) {
                $(sliderContainer).slick('unslick');
            }

           
            let imgLoadCounter = 0;

            images.forEach(function (imageSrc) {
                if (imageSrc) {
                    let imgElement = document.createElement('img');
                    imgElement.src = imageSrc;

                    imgElement.onload = function() {
                        imgLoadCounter++;
                        if (imgLoadCounter === images.length) {
                            
                            console.log("All images loaded, initializing Slick Slider");
                            $(sliderContainer).slick({
                                dots: true,
                                arrows: true,
                                infinite: true,
                                speed: 300,
                                slidesToShow: 1,
                                adaptiveHeight: true
                            });
                    
                            window.dispatchEvent(new Event('resize'));
                        }
                    };

                    imgElement.onerror = function() {
                        console.error("Error loading image:", imageSrc);
                        imgLoadCounter++;
                        if (imgLoadCounter === images.length) {
                      
                            console.log("All images processed (some errors), initializing Slick Slider");
                            $(sliderContainer).slick({
                                dots: true,
                                arrows: true,
                                infinite: true,
                                speed: 300,
                                slidesToShow: 1,
                                adaptiveHeight: true
                            });
                            window.dispatchEvent(new Event('resize'));
                        }
                    };

                    sliderContainer.appendChild(imgElement);
                }
            });

        
            if (images.length === 0) {
                console.warn("No images found, initializing Slick Slider without images");
                $(sliderContainer).slick({
                    dots: true,
                    arrows: true,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    adaptiveHeight: true
                });
                window.dispatchEvent(new Event('resize'));
            }
        }

        options.forEach(option => {
            let optionName = option.name || "Unknown Option";
            let values = Array.isArray(option.values) ? option.values : [];

            let optionWrapper = document.createElement('div');
            optionWrapper.classList.add('product-option');

            let optionTitle = document.createElement('h4');
            optionTitle.textContent = optionName;
            optionWrapper.appendChild(optionTitle);

            let optionGroup = document.createElement('div');
            optionGroup.classList.add('option-group');

            values.forEach(value => {
                let label = document.createElement('label');
                label.classList.add('option-label');

                let radio = document.createElement('input');
                radio.type = 'radio';
                radio.name = optionName;
                radio.value = value;
                radio.classList.add('option-radio');
                radio.style.display = "none";

                let backgroundColor = null;

                if (optionName.toLowerCase().includes("color") || optionName.toLowerCase().includes("colour")) {
                    if (isValidColor(value)) {
                        backgroundColor = value;
                    } else {
                        backgroundColor = extractColor(value);
                    }
                }

                label.appendChild(radio);
                label.appendChild(document.createTextNode(value));

                label.addEventListener('click', function () {
                    let allRadios = optionGroup.querySelectorAll('.option-radio');
                    allRadios.forEach(r => r.checked = false);
                    radio.checked = true;
                    modalProductData.selectedOptions[optionName] = value;

                    let matchingVariant = findMatchingVariant(modalProductData.selectedOptions, variants, data);
                    updatePrice(matchingVariant, data, salePriceElement, comparePriceElement);

                    if (matchingVariant) {
                        modalProductData.variantId = matchingVariant.id;
                        console.log("Selected Variant ID:", modalProductData.variantId);
                        setAddToCartButtonState(addToCartButton, true);
                    } else {
                        modalProductData.variantId = null;
                        setAddToCartButtonState(addToCartButton, false);
                        console.warn("No matching variant found for selected options.");
                    }

                    let allLabels = optionGroup.querySelectorAll('.option-label');
                    allLabels.forEach(lbl => lbl.style.border = "1px solid #ccc");
                    label.style.border = "1px solid black";
                });

                optionGroup.appendChild(label);
            });

            optionWrapper.appendChild(optionGroup);
            optionsContainer.appendChild(optionWrapper);
        });

    
        quantityInput.min = 1;
        quantityInput.step = 1;
     

   
        let plusClickHandler = function () {
            let currentValue = parseInt(quantityInput.value);
            quantityInput.value = currentValue + 1;
            modalProductData.quantity = parseInt(quantityInput.value);
            console.log("current quanity clicked plus button", modalProductData.quantity);
        };

        let minusClickHandler = function () {
            let currentValue = parseInt(quantityInput.value);
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
                modalProductData.quantity = parseInt(quantityInput.value);
                console.log("current quanity clicked minus button", modalProductData.quantity);
            }
        };

        plusButton.addEventListener('click', plusClickHandler);
        minusButton.addEventListener('click', minusClickHandler);

        plusButton.plusClickHandler = plusClickHandler;
        minusButton.minusClickHandler = minusClickHandler;

        if (addToCartButton) {
            addToCartButton.addEventListener('click', function (event) {
                event.preventDefault();

                if (!modalProductData.variantId) {
                    alert("Please select product options before adding to cart.");
                    return;
                }

                console.log("Adding to cart:");
                console.log("  Variant ID:", modalProductData.variantId);
                console.log("  Quantity:", modalProductData.quantity);

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        quantity: modalProductData.quantity,
                        id: modalProductData.variantId
                    })
                })
                    .then(response => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then(data => {
                        console.log('Success:', data);
                        alert("Product added to cart!");
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        alert("Error adding product to cart.");
                    });
            });
        } else {
            console.warn("Add to cart button not found.");
        }

        setAddToCartButtonState(addToCartButton, false);

        let modalContainer = document.querySelector('.modalWrapper .container');
        if (modalContainer) {
            modalContainer.classList.add('active');
        } else {
            console.warn("Modal Container not found")
        }

        let matchingVariant = findMatchingVariant({}, variants, data);
        updatePrice(matchingVariant, data, salePriceElement, comparePriceElement);
        titleElement.textContent = title;
        descriptionElement.innerHTML = description;
    }

    function closeModal() {
        let modalWrapper = document.querySelector('.modalWrapper');
        if (modalWrapper) {
            let sliderContainer = document.querySelector('.product-side-quick_view-slider');
            let titleElement = document.querySelector('.product-title-side-quick_view');
            let salePriceElement = document.querySelector('.current-sale-price');
            let comparePriceElement = document.querySelector('.current-compare-price');
            let descriptionElement = document.querySelector('.product-description-qucik_view');
            let modalContainer = document.querySelector('.modalWrapper .container');
            let optionsContainer = document.querySelector('.option-list-items');
            let quantityInput = document.querySelector('.modalWrapper .input-quantity-wrapper input[type="number"]');
            let plusButton = document.querySelector('.modalWrapper .input-quantity-wrapper .plus-icon');
            let minusButton = document.querySelector('.modalWrapper .input-quantity-wrapper .minus-icon');
            let addToCartButton = document.querySelector('a.add-to-cart-actual-button');

            if (modalContainer) {
                modalContainer.classList.remove('active');
            }

            if (sliderContainer) {

                if (typeof $ !== "undefined" && $(sliderContainer).hasClass('slick-initialized')) {
                    try {
                        $(sliderContainer).slick('unslick');
                    } catch (slickError) {
                        console.error("Error destroying Slick Slider:", slickError);
                    }
                }
                sliderContainer.innerHTML = '';
            }
            if (titleElement) titleElement.textContent = '';
            if (salePriceElement) salePriceElement.textContent = '';
            if (comparePriceElement) comparePriceElement.textContent = '';
            if (descriptionElement) descriptionElement.innerHTML = '';
            if (optionsContainer) optionsContainer.innerHTML = '';
            if (quantityInput) quantityInput.value = 1;
            if (addToCartButton) setAddToCartButtonState(addToCartButton, false);
            modalWrapper.classList.remove('active');
           
     
            modalProductData = {
                handle: null,
                variantId: null,
                quantity: 1,
                selectedOptions: {}
            };

  
            if (plusButton && plusButton.plusClickHandler) {
                plusButton.removeEventListener('click', plusButton.plusClickHandler);
                plusButton.plusClickHandler = null;
            }

            if (minusButton && minusButton.minusClickHandler) {
                minusButton.removeEventListener('click', minusButton.minusClickHandler);
                minusButton.minusClickHandler = null;
            }

        }
    }

    body.addEventListener('click', function (event) {
        if (event.target && event.target.classList.contains('quick-view-button')) {
            event.preventDefault();

            const quickViewButton = event.target;
            let productHandle = quickViewButton.getAttribute('data-handle');

            if (!productHandle) {
                console.error("Product handle is missing from the quick view button.");
                return;
            }

            modalProductData = {
                handle: productHandle,
                variantId: null,
                quantity: 1,
                selectedOptions: {}
            };

            let productUrl = `${window.location.origin}/products/${productHandle}.js`;

            fetch(productUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error(`Network response was not ok: ${response.status} ${response.statusText}`);
                    }
                    return response.json();
                })
                .then(data => {
                    populateModal(data);
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
        }
         if (event.target && event.target.classList.contains('closeModal')) {
            closeModal();
        }

    });

    let modalWrapper = document.querySelector('.modalWrapper');
    if (modalWrapper) {
        modalWrapper.addEventListener('click', function (e) {
            if (!e.target.closest('.container')) {
                closeModal();
            }
        });
    }
});